(function () {
  if (window.__simplerBlogEnjoyedReadingBound) return;
  window.__simplerBlogEnjoyedReadingBound = true;

  function parseNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function mountEnjoyedReadingSliders(root) {
    if (typeof Swiper === 'undefined') return;

    root.querySelectorAll('[data-sbaer-slider]').forEach(function (slider) {
      var el = slider.querySelector('.sbaer-swiper');
      if (!el) return;

      var slides = el.querySelectorAll('.swiper-slide');
      if (slides.length === 0) return;

      if (el.swiper) {
        el.swiper.destroy(true, true);
      }

      var scrollbarEl = slider.querySelector('.sbaer-scrollbar');
      var slidesMobile = parseNumber(slider.dataset.slidesMobile, 1.2);
      var slidesTablet = parseNumber(slider.dataset.slidesTablet, 2.4);
      var slidesDesktop = parseNumber(slider.dataset.slidesDesktop, 4);
      var gapMobile = parseNumber(slider.dataset.gapMobile, 16);
      var gapTablet = parseNumber(slider.dataset.gapTablet, 20);
      var gapDesktop = parseNumber(slider.dataset.gapDesktop, 24);

      new Swiper(el, {
        slidesPerView: slidesMobile,
        spaceBetween: gapMobile,
        speed: 450,
        watchOverflow: true,
        grabCursor: true,
        simulateTouch: true,
        scrollbar: scrollbarEl
          ? {
              el: scrollbarEl,
              draggable: true,
              dragSize: 'auto',
            }
          : undefined,
        breakpoints: {
          769: {
            slidesPerView: slidesTablet,
            spaceBetween: gapTablet,
          },
          1200: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop,
          },
        },
      });
    });
  }

  function boot() {
    mountEnjoyedReadingSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (!root) return;
    mountEnjoyedReadingSliders(root);
  });
})();
